/* eslint-disable max-len */
import { SvgProps } from '@main/core-ui/src/Icon/constants/enums';
import React from 'react';

export const ArrowRotate: React.FC<SvgProps> = ({ color, size }) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M3.75998 3.86621V6.81288H6.70581H3.75998"
      stroke={color}
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M4.14413 6.81266C5.27496 4.74016 7.47329 3.3335 9.99996 3.3335C13.6816 3.3335 16.6666 6.3185 16.6666 10.0002C16.6666 13.6818 13.6816 16.6668 9.99996 16.6668C6.31829 16.6668 3.33329 13.6818 3.33329 10.0002"
      stroke={color}
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);
/* eslint-enable max-len */
